import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import './Account.css';

const Account = () => {
  const [mode, setMode] = useState('login');
  const [loginData, setLoginData] = useState({ gameId: '', password: '' });
  const [registerData, setRegisterData] = useState({
    qqNumber: '',
    groupNickname: '',
    gameId: '',
    password: '',
    confirmPassword: ''
  });
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({
    qqNumber: '',
    groupNickname: '',
    gameId: '',
    password: ''
  });
  const [appealMode, setAppealMode] = useState('');
  const [appealData, setAppealData] = useState({ gameId: '', reason: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const { user, login, register, logout, updateProfile } = useContext(AuthContext);

  useEffect(() => {
    if (user) {
      setEditData({
        qqNumber: user.qqNumber,
        groupNickname: user.groupNickname,
        gameId: user.gameId,
        password: ''
      });
    }
  }, [user]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    try {
      console.log('尝试登录:', loginData.gameId);
      await login(loginData.gameId, loginData.password);
      console.log('登录成功');
    } catch (err) {
      const msg = err.response?.data?.message || err.message || '登录失败';
      console.error('登录失败:', msg);
      setErrorMessage(msg);
      alert('登录失败: ' + msg);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    if (registerData.password !== registerData.confirmPassword) {
      setErrorMessage('两次密码不一致');
      alert('两次密码不一致');
      return;
    }
    try {
      await register(registerData);
    } catch (err) {
      const msg = err.response?.data?.message || err.message || '注册失败';
      console.error('注册失败:', msg);
      setErrorMessage(msg);
      alert('注册失败: ' + msg);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(editData);
      setEditMode(false);
      alert('更新成功');
    } catch (err) {
      alert('更新失败');
    }
  };

  const handleAppeal = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/users/appeal', {
        type: appealMode,
        ...appealData
      });
      alert('申诉已提交');
      setAppealMode('');
      setAppealData({ gameId: '', reason: '' });
    } catch (err) {
      alert('提交失败');
    }
  };

  const handleDeleteAccount = async () => {
    if (window.confirm('确定要注销账号吗？此操作不可逆！')) {
      if (window.confirm('再次确认：所有数据将被永久删除！')) {
        try {
          await axios.delete('/users/account');
          alert('账号已注销');
          logout();
        } catch (err) {
          alert('注销失败');
        }
      }
    }
  };

  if (user) {
    return (
      <div className="account">
        <h1>账号管理</h1>
        <div className="account-info">
          <div className="info-row">
            <span className="label">游戏ID:</span>
            <span className="value">{user.gameId}</span>
          </div>
          <div className="info-row">
            <span className="label">QQ号:</span>
            <span className="value">{user.qqNumber}</span>
          </div>
          <div className="info-row">
            <span className="label">群昵称:</span>
            <span className="value">{user.groupNickname}</span>
          </div>
          <div className="info-row">
            <span className="label">权限:</span>
            <span className="value">{user.permission}</span>
          </div>
          <div className="info-row">
            <span className="label">白名单:</span>
            <span className="value">{user.whitelisted ? '已通过' : '未申请'}</span>
          </div>
          <div className="info-row">
            <span className="label">OP权限:</span>
            <span className="value">{user.opApproved ? '已通过' : '未申请'}</span>
          </div>
        </div>
        <div className="account-actions">
          <button onClick={() => setEditMode(!editMode)} className="btn-primary">
            {editMode ? '取消编辑' : '编辑资料'}
          </button>
          <button onClick={() => setAppealMode(setAppealMode ? '' : 'ban')} className="btn-secondary">
            申诉账号
          </button>
          <button onClick={logout} className="btn-secondary">
            退出登录
          </button>
          <button onClick={handleDeleteAccount} className="btn-danger">
            注销账号
          </button>
        </div>
        {editMode && (
          <form onSubmit={handleEdit} className="edit-form">
            <input
              type="text"
              placeholder="QQ号"
              value={editData.qqNumber}
              onChange={(e) => setEditData({ ...editData, qqNumber: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="群昵称"
              value={editData.groupNickname}
              onChange={(e) => setEditData({ ...editData, groupNickname: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="游戏ID"
              value={editData.gameId}
              onChange={(e) => setEditData({ ...editData, gameId: e.target.value })}
              required
            />
            <input
              type="password"
              placeholder="新密码（留空则不修改）"
              value={editData.password}
              onChange={(e) => setEditData({ ...editData, password: e.target.value })}
            />
            <button type="submit" className="btn-primary">保存修改</button>
          </form>
        )}
        {appealMode && (
          <form onSubmit={handleAppeal} className="appeal-form">
            <input
              type="text"
              placeholder="游戏ID"
              value={appealData.gameId}
              onChange={(e) => setAppealData({ ...appealData, gameId: e.target.value })}
              required
            />
            <textarea
              placeholder="申诉理由"
              value={appealData.reason}
              onChange={(e) => setAppealData({ ...appealData, reason: e.target.value })}
              rows={5}
              required
            />
            <button type="submit" className="btn-primary">提交申诉</button>
          </form>
        )}
      </div>
    );
  }

  return (
    <div className="account">
      <h1>账号</h1>
      <div className="auth-tabs">
        <button
          className={mode === 'login' ? 'active' : ''}
          onClick={() => { setMode('login'); setErrorMessage(''); }}
        >
          登录
        </button>
        <button
          className={mode === 'register' ? 'active' : ''}
          onClick={() => { setMode('register'); setErrorMessage(''); }}
        >
          注册
        </button>
      </div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      {mode === 'login' && (
        <form onSubmit={handleLogin} className="auth-form">
          <input
            type="text"
            placeholder="游戏ID"
            value={loginData.gameId}
            onChange={(e) => setLoginData({ ...loginData, gameId: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="密码"
            value={loginData.password}
            onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            required
          />
          <button type="submit" className="btn-primary">登录</button>
        </form>
      )}
      {mode === 'register' && (
        <form onSubmit={handleRegister} className="auth-form">
          <input
            type="text"
            placeholder="QQ号"
            value={registerData.qqNumber}
            onChange={(e) => setRegisterData({ ...registerData, qqNumber: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="群昵称"
            value={registerData.groupNickname}
            onChange={(e) => setRegisterData({ ...registerData, groupNickname: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="游戏ID"
            value={registerData.gameId}
            onChange={(e) => setRegisterData({ ...registerData, gameId: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="密码"
            value={registerData.password}
            onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="确认密码"
            value={registerData.confirmPassword}
            onChange={(e) => setRegisterData({ ...registerData, confirmPassword: e.target.value })}
            required
          />
          <button type="submit" className="btn-primary">注册</button>
        </form>
      )}
    </div>
  );
};

export default Account;
